import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { Fragment, useState, useMemo, useEffect } from 'react';
import { Box, Button, Card, createForm, DescriptionList, Dialog, Flex, GridAlpha, Heading, Notice, ProgressIndicator, Select, Tabs, Text, Textarea, useId, useToasts } from '@applyboard/crystal-ui';
import { CheckMarkOutlineIcon, PlayArrowOutlineIcon } from '@applyboard/ui-icons';
import { ApplicationClipboardIllustration, ApplicationRejectedIllustration } from "../../illustrations";
import { decideShouldShowField, DynamicForm, isEmptyValue, ReadableValue, isFieldComponent } from "../../components/DynamicForm";
import { usePermissions, useEvaluationTask, useCreateEvaluationTask, useCompleteTask, useRejectTask, useSnoozeTask, useDeleteTask, useManualTaskStatistics, useTaskId, useStartEvaluationTask } from "./data";
import { ErrorBoundary } from 'react-error-boundary';
import { IllustratedErrorState } from "../../components/IllustratedErrorState";
import { useEventTracker, useCurrentUser, request as _request } from '@applyboard/ui-utils';
import { z } from 'zod';
import { useHistory, useParams } from 'react-router-dom';
import { assert } from "../../utils/assert";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
export function RoadRunnerDashboardPage() {
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _useParams = useParams(),
    taskId = _useParams.taskId;
  return _jsx(ErrorBoundary, {
    onError: function onError(error) {
      return trackEvent({
        event: taskId ? 'Road Runner Task Page - View Page Error' : 'Road Runner Dashboard - View Page Error',
        error: error
      });
    },
    fallbackRender: function fallbackRender(_ref) {
      var error = _ref.error;
      return _jsx(RoadRunnerDashboardPageError, {
        error: error
      });
    },
    children: _jsx(RoadRunnerDashboardPageLoader, {})
  });
}
function RoadRunnerDashboardPageLoader() {
  var _usePermissions = usePermissions(),
    isLoadingPermissions = _usePermissions.isLoadingPermissions,
    permissions = _usePermissions.permissions;
  if (isLoadingPermissions) {
    return _jsx(Box, {
      px: 20,
      children: _jsx(Flex, {
        align: "center",
        justify: "center",
        pt: 4,
        children: _jsx(ProgressIndicator, {
          size: "lg",
          label: "Loading...",
          variant: "circular",
          indeterminate: true
        })
      })
    });
  }
  return _jsx(Box, {
    px: 20,
    children: _jsx(RoadRunnerDashboard, {
      permissions: permissions
    })
  });
}

/**
 * A page for CX to use to perform manual tasks for the road runner system
 */
export function RoadRunnerDashboard(_ref2) {
  var _evaluationTask$assig, _evaluationTask$fileC, _evaluationTask$fileC2, _evaluationTask$fileC3;
  var permissions = _ref2.permissions;
  useRemoveAllQueryParams();
  var _useCurrentUser = useCurrentUser(),
    _useCurrentUser2 = _slicedToArray(_useCurrentUser, 1),
    currentUser = _useCurrentUser2[0];
  assert(currentUser === null || currentUser === void 0 ? void 0 : currentUser.id, 'Failed to load current user');
  var hasViewOrUpdatePermissions = (permissions === null || permissions === void 0 ? void 0 : permissions['view_road_runner_dashboard']) || (permissions === null || permissions === void 0 ? void 0 : permissions['update_road_runner_dashboard']);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    dataToSubmit = _useState2[0],
    setDataToSubmit = _useState2[1];
  var _useEvaluationTask = useEvaluationTask(),
    evaluationTask = _useEvaluationTask.evaluationTask;
  var _useSnoozeTask = useSnoozeTask(),
    snoozeEvaluationTask = _useSnoozeTask.snoozeEvaluationTask,
    isSnoozingTask = _useSnoozeTask.isSnoozingTask;
  var _useDeleteTask = useDeleteTask(),
    deleteEvaluationTask = _useDeleteTask.deleteEvaluationTask,
    isDeletingTask = _useDeleteTask.isDeletingTask;
  var _useCompleteTask = useCompleteTask(),
    completeEvaluationTask = _useCompleteTask.completeEvaluationTask,
    isCompletingTask = _useCompleteTask.isCompletingTask;
  var _useRejectTask = useRejectTask(),
    rejectEvaluationTask = _useRejectTask.rejectEvaluationTask,
    isRejectingTask = _useRejectTask.isRejectingTask;
  var _useStartEvaluationTa = useStartEvaluationTask(),
    startEvaluationTask = _useStartEvaluationTa.startEvaluationTask,
    isStartingEvaluationTask = _useStartEvaluationTa.isStartingEvaluationTask;
  var isUpdatingTaskStatus = isSnoozingTask || isDeletingTask;
  var toasts = useToasts();
  var formHeadingId = useId();
  var formId = useId();
  var _useParams2 = useParams(),
    taskIdParam = _useParams2.taskId;
  if (!evaluationTask) {
    return _jsx(StartNewTaskButton, {});
  }
  if (evaluationTask.status.toLowerCase() !== 'executing' && evaluationTask.status.toLowerCase() !== 'pending execution') {
    return _jsxs(Notice, {
      intent: "primary",
      children: ["Task cannot be viewed since it is \u201C", evaluationTask.status, "\u201D"]
    });
  }
  if (!hasViewOrUpdatePermissions) {
    return _jsx(Notice, {
      intent: "negative",
      children: "You do not have the permissions to view this page."
    });
  }
  var isAssignedToMe = ((_evaluationTask$assig = evaluationTask.assigneeLegacyId) === null || _evaluationTask$assig === void 0 ? void 0 : _evaluationTask$assig.toString()) === currentUser.id.toString();
  var taskInProgress = !taskIdParam || isAssignedToMe;
  return _jsxs(_Fragment, {
    children: [evaluationTask.notices.map(function (notice) {
      return _jsx(Notice, {
        intent: notice.intent,
        children: notice.message
      }, notice.message);
    }), _jsxs(Flex, {
      justify: "between",
      direction: {
        xs: 'column',
        md: 'row'
      },
      py: 4,
      children: [_jsxs(Flex, {
        pb: {
          xs: 2,
          md: 0
        },
        direction: "column",
        gap: 4,
        children: [_jsx(Heading, {
          level: 1,
          variant: "headlineM",
          children: evaluationTask.taskTitle
        }), _jsxs(Text, {
          variant: "titleM",
          children: ["Application ID: ", evaluationTask.applicationNumber || evaluationTask.applicationId]
        })]
      }), taskInProgress ? _jsxs(Flex, {
        gap: 2,
        children: [!!evaluationTask.rejectionOptions.length && _jsx(RejectTaskDialog, {
          onSubmit: function onSubmit(_ref3) {
            var id = _ref3.id,
              rejectionOptionCode = _ref3.rejectionOptionCode,
              taskTitle = _ref3.taskTitle,
              notes = _ref3.notes;
            rejectEvaluationTask({
              id: id,
              rejectionOptionCode: rejectionOptionCode,
              notes: notes
            }, {
              onSuccess: function onSuccess() {
                toasts.positive("Task \"".concat(taskTitle, "\" has been successfully rejected!"));
              },
              onError: function onError() {
                toasts.negative(new Error('Error while trying to reject task'));
              }
            });
          },
          isSubmitting: isRejectingTask
        }), _jsx(DeleteTaskDialog, {
          isCompletingTask: isCompletingTask,
          isSubmitting: isUpdatingTaskStatus,
          onSubmit: function onSubmit() {
            deleteEvaluationTask({
              id: evaluationTask.id
            }, {
              onSuccess: function onSuccess() {
                toasts.positive('Successfully deleted task');
              },
              onError: function onError() {
                toasts.negative(new Error('Error while trying to delete task'));
              }
            });
          }
        }), _jsx(Button, {
          emphasis: "outlined",
          intent: "primary",
          onClick: function onClick() {
            snoozeEvaluationTask({
              id: evaluationTask.id
            }, {
              onSuccess: function onSuccess() {
                toasts.positive('Successfully snoozed task');
              },
              onError: function onError() {
                toasts.negative(new Error('Error while trying to snooze task'));
              }
            });
          },
          loading: isUpdatingTaskStatus,
          disabled: isCompletingTask,
          children: "Snooze"
        }), _jsx(CompleteTaskDialog, {
          formDefinition: evaluationTask.formDefinition,
          formId: formId,
          isDroppingTask: isUpdatingTaskStatus,
          isSubmitting: isCompletingTask,
          evaluationTask: evaluationTask,
          dataToSubmit: dataToSubmit,
          onOpenChange: function onOpenChange(newValue) {
            if (!newValue && !isCompletingTask) {
              setDataToSubmit(null);
            }
          },
          onSubmit: function onSubmit() {
            if (!dataToSubmit) return;
            completeEvaluationTask({
              id: evaluationTask.id,
              values: dataToSubmit.data
            }, {
              onSuccess: function onSuccess() {
                setDataToSubmit(null);
                toasts.positive("Task \"".concat(evaluationTask.taskTitle, "\" has been successfully completed!"));
              },
              onError: function onError() {
                toasts.negative(new Error('Error while trying to complete task'));
              }
            });
          }
        })]
      }) : _jsx(Button, {
        intent: "primary",
        leadIcon: PlayArrowOutlineIcon,
        loading: isStartingEvaluationTask,
        onClick: function onClick() {
          return startEvaluationTask({
            id: evaluationTask.id
          }, {
            onSuccess: function onSuccess() {
              return toasts.positive("Started task \"".concat(evaluationTask.taskTitle, "\""));
            },
            onError: function onError(err) {
              return toasts.negative(err);
            }
          });
        },
        children: "Start task"
      })]
    }), _jsxs(Flex, {
      gap: 6,
      direction: {
        xs: 'column',
        md: 'row'
      },
      justify: (_evaluationTask$fileC = evaluationTask.fileContent) !== null && _evaluationTask$fileC !== void 0 && _evaluationTask$fileC.length ? 'start' : 'center',
      children: [!!((_evaluationTask$fileC2 = evaluationTask.fileContent) !== null && _evaluationTask$fileC2 !== void 0 && _evaluationTask$fileC2.length) && _jsx(Flex.Item, {
        grow: 1,
        children: _jsx(PreviewArea, {
          fileGroups: evaluationTask.fileContent
        })
      }), _jsx(Flex.Item, {
        grow: 0,
        shrink: 0,
        basis: (_evaluationTask$fileC3 = evaluationTask.fileContent) !== null && _evaluationTask$fileC3 !== void 0 && _evaluationTask$fileC3.length ? '440px' : '800px',
        children: _jsx(Card, {
          children: _jsxs(Flex, {
            direction: "column",
            gap: 4,
            children: [_jsx(Heading, {
              id: formHeadingId,
              level: 2,
              variant: "titleM",
              children: "Extraction Form"
            }), _jsx(DynamicForm, {
              formDefinition: evaluationTask.formDefinition,
              formId: formId,
              hideFormActions: true,
              hideFormInstructions: true,
              onSubmit: function onSubmit(data, _ref4) {
                var metadata = _ref4.metadata;
                return setDataToSubmit({
                  data: data,
                  metadata: metadata
                });
              },
              "aria-labelledby": formHeadingId,
              validationNoticeText: "Please provide missing responses and/or correct erroneous responses. You are not able to proceed until then."
              // TODO: write test for this
              ,
              request: function request(url) {
                return _request(url, {
                  schema: z.unknown()
                });
              },
              disabled: !taskInProgress
            })]
          })
        })
      })]
    })]
  });
}

/**
 * Removes all query params from the url using history.replace
 */
function useRemoveAllQueryParams() {
  var history = useHistory();

  // eslint-disable-next-line no-restricted-syntax -- This use-case is okay because we want to remove the query params on page load
  useEffect(function () {
    if (history.location.search) {
      history.replace(history.location.pathname);
    }
  }, [history]);
}
function DeleteTaskDialog(_ref5) {
  var isCompletingTask = _ref5.isCompletingTask,
    isSubmitting = _ref5.isSubmitting,
    onSubmit = _ref5.onSubmit;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpen = _useState4[0],
    setIsOpen = _useState4[1];
  return _jsxs(Dialog, {
    open: isOpen,
    onOpenChange: setIsOpen,
    children: [_jsx(Dialog.Trigger, {
      children: _jsx(Button, {
        emphasis: "outlined",
        intent: "negative",
        disabled: isCompletingTask,
        children: "Delete"
      })
    }), _jsx(Dialog.Heading, {
      children: "Delete the Task?"
    }), _jsx(Dialog.Content, {
      children: _jsx(Text, {
        children: "Please confirm that you want to delete this task. Once your confirmation is provided, you will not be able to modify the task."
      })
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        emphasis: "highlighted",
        intent: "secondary",
        disabled: isSubmitting,
        width: "fill",
        children: "Cancel"
      }), _jsx(Button, {
        emphasis: "contained",
        intent: "negative",
        onClick: onSubmit,
        loading: isSubmitting,
        width: "fill",
        children: "Delete task"
      })]
    })]
  });
}
function CompleteTaskDialog(_ref6) {
  var evaluationTask = _ref6.evaluationTask,
    formId = _ref6.formId,
    formDefinition = _ref6.formDefinition,
    isDroppingTask = _ref6.isDroppingTask,
    isSubmitting = _ref6.isSubmitting,
    onOpenChange = _ref6.onOpenChange,
    onSubmit = _ref6.onSubmit,
    dataToSubmit = _ref6.dataToSubmit;
  return _jsxs(Dialog, {
    open: dataToSubmit !== null,
    onOpenChange: onOpenChange,
    children: [_jsx(Dialog.Trigger, {
      children: _jsx(Button, {
        type: "submit",
        intent: "primary",
        form: formId,
        disabled: isDroppingTask,
        leadIcon: CheckMarkOutlineIcon,
        children: "Complete task"
      })
    }), _jsx(Dialog.Heading, {
      children: "Complete the Task?"
    }), _jsx(Dialog.Content, {
      children: _jsxs(Flex, {
        direction: "column",
        gap: 4,
        children: [_jsxs(Text, {
          children: ["You're about to complete the task \"", evaluationTask.taskTitle, "\". Please carefully review the manually extracted values below."]
        }), _jsx(DescriptionList, {
          variant: "free",
          children: _jsx(GridAlpha, {
            columns: "fit-content(80%) fit-content(80%)",
            columnGap: 4,
            rowGap: 4,
            children: formDefinition.components.map(function (component, index) {
              return _jsx(ReadonlyField, {
                index: index,
                component: component,
                formData: dataToSubmit === null || dataToSubmit === void 0 ? void 0 : dataToSubmit.data,
                formMetadata: dataToSubmit === null || dataToSubmit === void 0 ? void 0 : dataToSubmit.metadata
              }, component.key);
            })
          })
        }), _jsx(Text, {
          children: "Please confirm that you want to complete the task. Once your confirmation is provided, you will not be able to modify the values."
        })]
      })
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        emphasis: "highlighted",
        intent: "secondary",
        disabled: isSubmitting,
        width: "fill",
        children: "Cancel"
      }), _jsx(Button, {
        emphasis: "contained",
        intent: "primary",
        leadIcon: CheckMarkOutlineIcon,
        onClick: onSubmit,
        loading: isSubmitting,
        width: "fill",
        children: "Complete task"
      })]
    })]
  });
}
function ReadonlyField(_ref7) {
  var index = _ref7.index,
    component = _ref7.component,
    formData = _ref7.formData,
    formMetadata = _ref7.formMetadata;
  var shouldShowField = useMemo(function () {
    if (!formData) {
      return false;
    }
    return decideShouldShowField(component, formData);
  }, [component, formData]);
  if (!shouldShowField || !formData) {
    return null;
  }
  var value = formData[component.key];
  if (isEmptyValue(value) || !isFieldComponent(component)) {
    return null;
  }
  return _jsxs(Fragment, {
    children: [_jsx(DescriptionList.Term, {
      children: component.label
    }), _jsx(DescriptionList.Details, {
      children: _jsx(ReadableValue, {
        value: value,
        component: component,
        formMetadata: formMetadata
      })
    })]
  }, index);
}
var _createForm = createForm(),
  RejectField = _createForm.Field,
  RejectForm = _createForm.Form,
  useRejectFieldValues = _createForm.useFieldValues;
function RejectTaskDialog(_ref8) {
  var _onSubmit = _ref8.onSubmit,
    isSubmitting = _ref8.isSubmitting;
  var formId = useId();
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpen = _useState6[0],
    setIsOpen = _useState6[1];
  var _useEvaluationTask2 = useEvaluationTask(),
    evaluationTask = _useEvaluationTask2.evaluationTask;
  if (!evaluationTask) {
    return null;
  }
  return _jsxs(Dialog, {
    open: isOpen,
    onOpenChange: setIsOpen,
    children: [_jsx(Dialog.Trigger, {
      children: _jsx(Button, {
        emphasis: "outlined",
        intent: "primary",
        children: "Reject"
      })
    }), _jsx(Dialog.Heading, {
      children: "Reject the Task?"
    }), _jsx(Dialog.Content, {
      children: _jsx(RejectForm, {
        defaultValues: {
          rejectionReason: '',
          additionalInformation: ''
        },
        id: formId,
        onSubmit: function onSubmit(formValues) {
          _onSubmit({
            id: evaluationTask.id,
            rejectionOptionCode: formValues.rejectionReason,
            taskTitle: evaluationTask.taskTitle,
            notes: formValues.additionalInformation.trim().length ? formValues.additionalInformation : undefined
          });
        },
        children: _jsxs(Flex, {
          direction: "column",
          gap: 3,
          children: [_jsxs(Text, {
            intent: "secondary",
            variant: "bodyS",
            children: ["You\u2019re about to reject the task \"", evaluationTask.taskTitle, "\". To be able to do that please describe a reason that caused this decision."]
          }), _jsx(RejectField, {
            as: Select,
            name: "rejectionReason",
            label: "Rejection reason",
            required: "Please select a rejection reason.",
            placeholder: "Select a reason from the list",
            appearance: "styled",
            children: evaluationTask.rejectionOptions.map(function (reason) {
              return _jsx(Select.Option, {
                label: reason.description,
                value: reason.code
              }, reason.code);
            })
          }), _jsx(AdditionalInformationTextarea, {
            rejectionReasons: evaluationTask.rejectionOptions
          }), _jsx(Text, {
            intent: "secondary",
            variant: "bodyS",
            children: "Please confirm that you want to reject the task. Once your confirmation is provided, you will not be able to modify the task."
          })]
        })
      })
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        children: "Cancel"
      }), _jsx(Button, {
        emphasis: "outlined",
        intent: "primary",
        type: "submit",
        form: formId,
        loading: isSubmitting,
        children: "Reject task"
      })]
    })]
  });
}
function AdditionalInformationTextarea(_ref9) {
  var _rejectionReasons$fin;
  var rejectionReasons = _ref9.rejectionReasons;
  var _useRejectFieldValues = useRejectFieldValues(),
    rejectionReason = _useRejectFieldValues.rejectionReason;
  if (!rejectionReason) {
    return null;
  }
  return _jsxs(_Fragment, {
    children: [_jsxs(Text, {
      intent: "secondary",
      variant: "bodyS",
      children: ["Feel free to provide additional information on why you think \"", (_rejectionReasons$fin = rejectionReasons.find(function (reason) {
        return reason.code === rejectionReason;
      })) === null || _rejectionReasons$fin === void 0 ? void 0 : _rejectionReasons$fin.description, "\""]
    }), _jsx(RejectField, {
      as: Textarea,
      name: "additionalInformation",
      label: "Additional information",
      required: "Please provide additional information about the rejection."
    })]
  });
}
function PreviewArea(_ref10) {
  var fileGroups = _ref10.fileGroups;
  var _useState7 = useState('0'),
    _useState8 = _slicedToArray(_useState7, 2),
    currentTab = _useState8[0],
    setCurrentTab = _useState8[1];
  return _jsx(Tabs, {
    value: currentTab,
    onChange: setCurrentTab,
    "aria-label": "Task files",
    children: fileGroups.map(function (fileGroup, index) {
      return _jsx(Tabs.Item, {
        value: index.toString(),
        label: fileGroup.groupTitle,
        children: fileGroup.files.map(function (file, index) {
          var _file$alerts;
          return _jsxs(Box, {
            pt: 4,
            children: [(_file$alerts = file.alerts) === null || _file$alerts === void 0 ? void 0 : _file$alerts.map(function (file, index) {
              return _jsx(Box, {
                pb: 4,
                children: _jsx(Notice, {
                  intent: "warning",
                  children: file.message
                })
              }, index);
            }), file.contentType === 'application/pdf' ?
            // Setting the height to 100% viewport height minus the navbar (plus some padding)
            _jsx("div", {
              style: {
                height: 'calc(100vh - 92px)',
                width: '100%',
                overflowY: 'auto'
              },
              children: _jsx("iframe", {
                title: file.fileName,
                src: file.fileDownloadLink,
                width: "100%",
                height: "100%"
              })
            }) : _jsx("img", {
              src: file.fileDownloadLink,
              alt: file.fileName,
              style: {
                width: '100%'
              }
            })]
          }, index);
        })
      }, index);
    })
  });
}
function StartNewTaskButton() {
  var _statistics$find$coun, _statistics$find;
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showEmptyState = _useState10[0],
    setShowEmptyState = _useState10[1];
  var _useCreateEvaluationT = useCreateEvaluationTask(),
    createEvaluationTask = _useCreateEvaluationT.createEvaluationTask,
    isCreatingEvaluationTask = _useCreateEvaluationT.isCreatingEvaluationTask;
  var toasts = useToasts();
  var _useManualTaskStatist = useManualTaskStatistics(),
    statistics = _useManualTaskStatist.statistics;
  var numberOfTasks = (_statistics$find$coun = (_statistics$find = statistics.find(function (s) {
    return s.status === 'pending_execution';
  })) === null || _statistics$find === void 0 ? void 0 : _statistics$find.count) !== null && _statistics$find$coun !== void 0 ? _statistics$find$coun : 0;
  var dashboardTitle = numberOfTasks === 0 ? 'There are no available tasks.' : numberOfTasks > 1 ? "There are ".concat(numberOfTasks, " tasks to complete.") : "There is ".concat(numberOfTasks, " task to complete.");
  return _jsx(_Fragment, {
    children: showEmptyState ? _jsx(EmptyState, {}) : _jsxs(Flex, {
      align: "center",
      justify: "center",
      direction: "column",
      gap: 8,
      pt: 16,
      pb: 36,
      children: [_jsx(ApplicationClipboardIllustration, {}), _jsxs(Flex, {
        direction: "column",
        gap: 4,
        align: "center",
        children: [_jsx(Text, {
          variant: "titleS",
          children: dashboardTitle
        }), _jsx(Text, {
          contrast: "mid",
          children: "Click the button below to start working on a new task."
        })]
      }), _jsx(Button, {
        intent: "primary",
        loading: isCreatingEvaluationTask,
        onClick: function onClick() {
          return createEvaluationTask(undefined, {
            onError: function onError() {
              toasts.negative(new Error('Failed to get next task'));
            },
            onSuccess: function onSuccess(_ref11) {
              var response = _ref11.response;
              if (!response.included.find(function (data) {
                return data.type === 'evaluation_task';
              })) {
                setShowEmptyState(true);
              }
            }
          });
        },
        children: "Complete task"
      })]
    })
  });
}
function EmptyState() {
  return _jsxs(Flex, {
    align: "center",
    justify: "center",
    direction: "column",
    gap: 4,
    pt: 16,
    pb: 36,
    children: [_jsx(ApplicationRejectedIllustration, {}), _jsx(Text, {
      variant: "titleS",
      children: "No tasks found!"
    }), _jsx(Text, {
      contrast: "mid",
      children: "Check back later for new tasks."
    })]
  });
}
function RoadRunnerDashboardPageError(_ref12) {
  var error = _ref12.error;
  var _useTaskId = useTaskId(),
    taskId = _useTaskId.taskId;
  return _jsx(IllustratedErrorState, {
    error: error,
    remediationButton: taskId ? _jsx(SnoozeTaskRemediationButton, {
      taskId: taskId
    }) : undefined,
    description: taskId ? "Oops! Our system encountered an error while trying to show this task.  We've been notified and we're on it!  In the meantime you can also snooze this task for later and move onto the next task" : undefined
  });
}
function SnoozeTaskRemediationButton(_ref13) {
  var taskId = _ref13.taskId;
  var _useSnoozeTask2 = useSnoozeTask(),
    snoozeEvaluationTask = _useSnoozeTask2.snoozeEvaluationTask,
    isSnoozingTask = _useSnoozeTask2.isSnoozingTask;
  var toasts = useToasts();
  return _jsx(Button, {
    emphasis: "outlined",
    intent: "primary",
    onClick: function onClick() {
      snoozeEvaluationTask({
        id: taskId
      }, {
        onSuccess: function onSuccess() {
          toasts.positive('Successfully snoozed task');
        },
        onError: function onError() {
          toasts.negative(new Error('Error while trying to snooze task'));
        }
      });
    },
    loading: isSnoozingTask,
    children: "Snooze Task"
  });
}